import classnames from 'classnames'
import { Button } from '@/components'

import Image from 'next/image'

import styles from './styles.module.scss'
import useMediaQuery from '@/utils/browser/getDeviceScreen'

const CardSinglePlan = ({ plan, variant, setOpenModal, onPlanSelected }) => {
  const isMobile = useMediaQuery('mobile')
  const buttonID = `btn-section-price-${plan?.value.split(',')[0]}`

  const list = isMobile ? plan?.list?.slice(0, 6) : plan?.list
  return (
    <div style={{ flex: '1 1' }}>
      <div
        className={classnames(styles.cardDetail, {
          [`${styles.cardDetailPink}`]: variant == 'pink',
          [`${styles.cardDetailWhite}`]: variant == 'white'
        })}
      >
        <div className={styles.disclaimer}>{plan?.disclaimer}</div>
        <div className={styles.content}>
          <div className={styles.images}>
            <Image
              className={styles.logo}
              src={plan?.logo}
              alt={`Plano ${plan?.disclaimer}`}
              width={242}
              height={109}
            />
            <Image
              className={styles.price}
              src={plan?.priceImage}
              alt={`Plano semestral`}
              width={282}
              height={198}
            />
          </div>

          <div className={styles.list}>
            {list.map((item, index) => {
              return (
                <div
                  key={index}
                  className={classnames(styles.planBenefits, {
                    [`${styles.hiddenOnMobile}`]: !item?.content
                  })}
                >
                  <Image
                    className={styles.price}
                    src={item?.icon}
                    alt={`Plano semestral`}
                    width={34}
                    height={32}
                  />
                  <h3>{item.content}</h3>
                </div>
              )
            })}
          </div>

          <div className={styles.action}>
            <Button
              variant="primary"
              id={buttonID}
              className={styles.button}
              onClick={() => {
                setOpenModal(true)
                onPlanSelected(plan.id)
              }}
            >
              APROVEITAR OFERTA
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CardSinglePlan
